import { useEffect, useRef } from "react";

/**
 * Creates a Ref together with a callback function that is being executed, when clicked outside the ref.
 * @param {Function} callback Function that is being executed on outside click.
 * @param {Boolean} condition Optional condition (e.g. some state) that is being checked, before the callback is executed.
 * @returns {React.Ref}
 */
const useOutsideClickHandler = (callback, condition = true, ignoreRef) => {
  const ref = useRef();
  useEffect(() => {
    if (!condition) return;

    const outsideClickHandler = ({ target }) => {
      const ignoreCondition = ignoreRef?.current ? !ignoreRef.current.contains(target) : true;

      if (!ref?.current?.contains(target) && ignoreCondition) callback();
    };

    // bind the listener
    document.addEventListener("click", outsideClickHandler, true);

    // unbind the listener (clean up)
    return () => {
      document.removeEventListener("click", outsideClickHandler, true);
    };
  }, [condition]);

  return ref;
};

export default useOutsideClickHandler;
